import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import SvcProtokolKemoterapi from "@/services/ProtokolKemoterapi";

@Module({ dynamic: true, namespaced: true, store, name: "protokolKemoterapi" })
class ProtokolKemoterapi extends VuexModule {
  listProtokol: any[] = [];
  loading = false;

  @Mutation
  SET_LIST(data: any[]) {
    this.listProtokol = data;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action({ rawError: true })
  async getByRegister(reg): Promise<void> {
    this.SET_LOADING(true);
    this.SET_LIST([]);
    const dt = await SvcProtokolKemoterapi.getByReg(reg).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_LIST(dt.data ? dt.data : []);
  }

  @Action reset() {
    this.SET_LIST([]);
  }
}

export default getModule(ProtokolKemoterapi);
